import React, { type ComponentType } from 'react';
import '@atlaskit/css-reset';
import {
	RedirectToArchivedPage,
	isProjectArchivedCondition,
} from '@atlassian/jira-redirect-archived-project/src/ui/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment';
import { withRouter, type RouteContext, useResource } from '@atlassian/react-resource-router';
import Pages from './view';

export type Props = RouteContext;

export const ProjectPages = () => {
	const projectContext = useResource(projectContextResource);
	const tenantContext = useTenantContext();

	if (isProjectArchivedCondition(projectContext.data)) {
		return <RedirectToArchivedPage />;
	}

	return (
		<UFOSegment name="project-pages">
			<AuthenticationCheck>
				{projectContext && (
					// @ts-expect-error - TS2322 - Type 'UseResourceHookResponse<ProjectContext | null>' is not assignable to type 'ProjectContextData'.
					<Pages projectContext={projectContext} tenantContext={tenantContext} />
				)}
			</AuthenticationCheck>
		</UFOSegment>
	);
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
export default withRouter(ProjectPages) as ComponentType<Record<any, any>>;
